// GATSBY_BOOKING_API switches the form from mock data to the real Supabase
// function. Without it (local development, Deploy Previews) nothing real is
// booked and no SMS is sent.
import * as mock from "./mockBackend"
import * as api from "./bookingApi"

// In development, ?mock in the address forces fake data even when the real
// function is configured, so the SMS and deposit screens can be seen without
// sending an SMS. Production builds ignore it.
const forceMock =
  process.env.NODE_ENV !== "production" &&
  typeof window !== "undefined" &&
  new URLSearchParams(window.location.search).has("mock")

const backend = process.env.GATSBY_BOOKING_API && !forceMock ? api : mock

export const isLiveBackend = backend === api

export const { STAGE } = mock
export const getVisitorId = (...a) => backend.getVisitorId(...a)
export const recordEvent = (...a) => backend.recordEvent(...a)
export const createLead = (...a) => backend.createLead(...a)
export const updateLead = (...a) => backend.updateLead(...a)
export const fetchSlots = (...a) => backend.fetchSlots(...a)
export const uploadPhotos = (...a) => backend.uploadPhotos(...a)
export const requestAppointment = (...a) => backend.requestAppointment(...a)
export const verifyAppointment = (...a) => backend.verifyAppointment(...a)
export const resendCode = (...a) => backend.resendCode(...a)
export const changeMobileNumber = (...a) => backend.changeMobileNumber(...a)
